export enum OrganizationLicenseModuleType {
    Manager = 0,
    Grower = 1,
    ThirdPartyApi = 2,
    ControlApi = 4,
    MCA = 6
}
